export default {
  '@type': 'MerchantReturnPolicy',
  'applicableCountry': 'ES',
  'merchantReturnLink': 'https://www.timberland.es/es-es/atencion-al-cliente/devoluciones',
  'returnPolicyCategory': 'https://schema.org/MerchantReturnFiniteReturnWindow',
  'returnMethod': 'https://schema.org/ReturnByMail',
  'merchantReturnDays': 30
}
